<script setup>
import { FilterButton } from '@dashhudson/dashing-ui/filter-button';
import { useFilterSidePanel } from '@dashhudson/dashing-ui/filter-side-panel';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useDateUtils } from '@/composables/useDateUtils';
import { REPORTING_PERIOD_PRESET_MAP } from '@/config';

const props = defineProps({
  scope: {
    type: String,
    default: undefined,
  },
  filter: {
    type: [String, Object],
    required: true,
  },
  hasComparisonPeriod: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  presetMap: {
    type: Object,
    default: () => REPORTING_PERIOD_PRESET_MAP,
  },
});

const route = useRoute();
const { scopedFilters } = useFilterSidePanel({ scope: () => props.scope });
const { getFormattedDateFromRange } = useDateUtils();

const isReport = computed(() => !!route?.meta?.report);

const reportingPeriod = computed(() =>
  typeof props.filter === 'string' ? scopedFilters?.value?.[props.filter] : props.filter,
);

const comparisonPeriod = computed(() => scopedFilters?.value?.comparisonPeriod);

function getLabelFromDateRangeObject(dateRangeObject) {
  const filterLabel = dateRangeObject?.preset;
  if (!filterLabel) return '';
  const { presetMap } = props;
  const showPreset =
    !isReport.value && presetMap[filterLabel] !== REPORTING_PERIOD_PRESET_MAP.CUSTOM;
  if (!showPreset && !dateRangeObject.range) return '';
  return showPreset ? presetMap[filterLabel] : getFormattedDateFromRange(dateRangeObject.range);
}
</script>

<template>
  <FilterButton
    :label="undefined"
    :disabled="props.disabled"
    icon="calendar"
    :filters="filter"
    variant="page"
  >
    <span class="filter-label">
      {{ getLabelFromDateRangeObject(reportingPeriod) }}
      <span v-if="hasComparisonPeriod" class="dash-text-subtle">vs</span>
      {{ getLabelFromDateRangeObject(comparisonPeriod) }}
    </span>
  </FilterButton>
</template>
